<template>
  <div class="my_clazz">
    <van-nav-bar
      title="我的班级"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />
    <in-clazz-panel v-for="(item, index) in joinList" :key="index" :clazz="item.clazz" />
    <div v-if="noList" class="empty">暂无班级</div>
  </div>
</template>

<script>
import { Cell, NavBar } from 'vant'
import InClazzPanel from '@/views/home/components/InClazzPanel'
import { joinClazzList } from '@/api/clazz'

export default {
  name: 'MyClazz',
  components: {
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    InClazzPanel
  },
  data () {
    return {
      isLoad: false,
      joinList: []
    }
  },
  computed: {
    noList () {
      return this.isLoad && !this.joinList.length
    }
  },
  created () {
    this.getJoinList()
  },
  methods: {
    async getJoinList () {
      let response = await joinClazzList()
      this.isLoad = true
      this.pullLoading = false
      this.joinList = response.data
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.empty {
  color: #969696;
  font-size: 28px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
